<template>
  <div class="user" style="margin-top:100px">
	   <!-- <div class="title">
          <span class="t1">专家</span>
          <span class="t2">一对一</span>
      </div> -->
      <!-- <div class="tail">Expert one-on-one</div> -->
	  <div class="container-fluid content"  style="width: 1280px;">
		  <div class="container"  style="width: 1280px;">
			  <div class="row" style="width: 1280px; flex-direction: row;display: flex;">
				  <div  style="width:320px;">
					  <div class="userImg">
						  <img src="../images/home/userbj2.png" alt="" class="bj">
						  <img class="img" :src="item.img" alt="" v-for="(item,index) in list" :key="index" v-if="xianshdi == item.index">
					  </div>
				  </div>
				  <div style="width: 960px;">
					  <div class="userDetail">
						  	<div class="name">
								<div class="l">洪涛老师</div>
								<div class="r">学院教学总监</div>
							</div>
							<div class="detail">人工智能硕士，ARM全球认证讲师，嵌入式专业教材撰稿人，在长达10年从业过程中，积累了非常丰富的项目&教学经验，帮助数万名学员进入华为、小米等知名企业，实现高薪职业梦想。曾负责项目：ETC控制、车牌识别等。</div>
							<div class="price">
								<div class="l">咨询价格：<span>￥189</span></div>
								<div class="r">我要一对一</div>
							</div>
					  </div>
					  <div class="userList">
						  <div class="" v-for="(item,index) in list" :key="index" @click="dianbao(item.index)" >
							  <img :src="item.img" alt="">
							  <div class="hui" @click="dianhui(item.index)" v-if="xianshdi !== item.index"></div>
						  </div>

					  </div>
				  </div>
			  </div>
		  </div>
	  </div>
	  <div class="button">在线咨询<img src="../images/home/Toright.png" alt=""></div>
  </div>
</template>

<script>
export default {
	data() {
		return {
			xianshdi:0,
			list:[
				{img:require("../images/home/user2.png"),index:0},
				{img:require("../images/home/homes1.png"),index:1},
				{img:require("../images/home/homes2.png"),index:2},
				{img:require("../images/home/homes3.png"),index:3},
				{img:require("../images/home/homes4.png"),index:4},
				{img:require("../images/home/homes5.png"),index:5},
				{img:require("../images/home/homes6.png"),index:6},
				{img:require("../images/home/homes7.png"),index:7},
			]
		}
	},
	methods: {
		dianbao(index){
			this.xianshdi = index
		},
		dianhui(index){
			this.xianshdi = index
		},

	}
}
</script>

<style>
	.hui{width: 100%;height: 100%;position: absolute;top: 0;left: 0;background: #9D2727;opacity: 0.23;cursor: pointer;}
	.hui2{width: 100%;height: 100%;position: absolute;top: 0;left: 0;background: #9D2727;opacity: 0.23;cursor: pointer;}


	.user{width: 100%;}
		.user>.title{width: 393px;height: 71px;background-image: url("../images/home/titbj.png");margin: 0px auto;background-size:100% 100% ;margin-top: 76px;font-size: 48px;font-weight: bold;text-align: center;}
		.user>.title>.t1{color: #000;}
		.user>.title>.t2{color: #E23737;}
		.user>.tail{color: #E2E2E2;font-size: 16px;text-align: center;}
		.user>.content{width:1500px;height:340px;margin-top: 40px;background-image: url("../images/home/userbj.png");background-repeat: no-repeat;background-size: 100% 100%;}
		.user>.content .userImg{position: relative;top: -30px;width: 293px;height: 407px;}
		.user>.content .userImg>.bj{width: 243px;height: 337px;}
		.user>.content .userImg>.img{width: 235px;height: 350px;position: absolute;top: 15px;left: -20px;}
		.user>.content .userDetail{margin-top: 10px;}
		.user>.content .userDetail>.name{display: flex;align-items: center;}
		.user>.content .userDetail>.name>.l{color: #fff;font-size: 25px;margin-right: 20px;}
		.user>.content .userDetail>.name>.r{width: 107px;height: 30px;color: #E23737;font-size: 14px;text-align: center;line-height: 30px;border-radius: 14px 14px 14px 0px;background-color: #fff;}
		.user>.content .userDetail>.detail{color: #fff;font-size: 12px;margin:10px 0px 5px 0px ;}
		.user>.content .userDetail>.price{display: flex;align-items: center;}
		.user>.content .userDetail>.price>.l{color: #fff;font-size: 16px;line-height: 30px;margin-right: 30px;display: flex;align-items: center;}
		.user>.content .userDetail>.price>.l>span{color: #F7FA04;font-size: 26px;}
		.user>.content .userDetail>.price>.r{width: 140px;height: 30px;color:  #FFFFFF;;border: 1px solid #FFFFFF;text-align: center;box-sizing: border-box;border-radius: 15px;line-height: 30px;cursor: pointer;}
		.user>.content .userList{margin-top: 80px;display: flex;}
		.user>.content .userList>div{width: 90px;height: 90px;margin-right: 10px;position: relative;}
		.user>.content .userList>div>img{width: 100%;}
		.user>.button{width: 382px;height: 56px;font-size: 24px;color:  #FFFFFF;background: linear-gradient(83deg, #F20E23, #F76636);text-align: center;box-sizing: border-box;border-radius: 28px;line-height: 66px;cursor: pointer;display: flex;align-items: center;justify-content: center;margin: 0px auto;margin-top: 40px;}
		.user>.button>img{width:26px;height: 26px;margin-left: 14px;}

	@media (min-width: 768px) {
		.user{width: 100%;}
		.user>.title{width: 393px;height: 71px;background-image: url("../images/home/titbj.png");margin: 0px auto;background-size:100% 100% ;margin-top: 76px;font-size: 48px;font-weight: bold;text-align: center;}
		.user>.title>.t1{color: #000;}
		.user>.title>.t2{color: #E23737;}
		.user>.tail{color: #E2E2E2;font-size: 16px;text-align: center;}
		.user>.content{height:390px;margin-top: 40px;background-image: url("../images/home/userbj.png");background-repeat: no-repeat;background-size: 100% 100%;}
		.user>.content .userImg{position: relative;top: -30px;width: 293px;height: 407px;}
		.user>.content .userImg>.bj{width: 243px;height: 337px;}
		.user>.content .userImg>.img{width: 235px;height: 350px;position: absolute;top: 15px;left: -20px;}
		.user>.content .userDetail{margin-left: 100px;margin-top: 10px;}
		.user>.content .userDetail>.name{display: flex;align-items: center;}
		.user>.content .userDetail>.name>.l{color: #fff;font-size: 25px;margin-right: 20px;}
		.user>.content .userDetail>.name>.r{width: 107px;height: 30px;color: #E23737;font-size: 14px;text-align: center;line-height: 30px;border-radius: 14px 14px 14px 0px;background-color: #fff;}
		.user>.content .userDetail>.detail{color: #fff;font-size: 12px;margin:10px 0px 15px 0px ;}
		.user>.content .userDetail>.price{display: flex;align-items: center;}
		.user>.content .userDetail>.price>.l{color: #fff;font-size: 16px;line-height: 30px;margin-right: 30px;display: flex;align-items: center;}
		.user>.content .userDetail>.price>.l>span{color: #F7FA04;font-size: 26px;}
		.user>.content .userDetail>.price>.r{width: 140px;height: 30px;color:  #FFFFFF;;border: 1px solid #FFFFFF;text-align: center;box-sizing: border-box;border-radius: 15px;line-height: 30px;cursor: pointer;}
		.user>.content .userList{margin-left: 100px;margin-top: 80px;display: flex;}
		.user>.content .userList>div{width: 90px;height: 90px;margin-right: 10px;}
		.user>.content .userList>div>img{width: 100%;}
		.user>.button{width: 382px;height: 56px;font-size: 24px;color:  #FFFFFF;background: linear-gradient(83deg, #F20E23, #F76636);text-align: center;box-sizing: border-box;border-radius: 28px;line-height: 66px;cursor: pointer;display: flex;align-items: center;justify-content: center;margin: 0px auto;margin-top: 40px;}
		.user>.button>img{width:26px;height: 26px;margin-left: 14px;}
	}
	@media (min-width:	992px) {
		.user{width: 100%;}
		.user>.title{width: 393px;height: 71px;background-image: url("../images/home/titbj.png");margin: 0px auto;background-size:100% 100% ;margin-top: 76px;font-size: 48px;font-weight: bold;text-align: center;}
		.user>.title>.t1{color: #000;}
		.user>.title>.t2{color: #E23737;}
		.user>.tail{color: #E2E2E2;font-size: 16px;text-align: center;}
		.user>.content{height:405px;margin-top: 40px;background-image: url("../images/home/userbj.png");background-repeat: no-repeat;background-size: 100% 100%;}
		.user>.content .userImg{position: relative;top: -40px;width: 293px;height: 407px;}
		.user>.content .userImg>.bj{width: 273px;height: 387px;}
		.user>.content .userImg>.img{width: 265px;height: 400px;position: absolute;top: 20px;left: -20px;}
		.user>.content .userDetail{margin-left: 60px;margin-top: 10px;}
		.user>.content .userDetail>.name{display: flex;align-items: center;}
		.user>.content .userDetail>.name>.l{color: #fff;font-size: 30px;margin-right: 20px;}
		.user>.content .userDetail>.name>.r{width: 137px;height: 30px;color: #E23737;font-size: 16px;text-align: center;line-height: 30px;border-radius: 14px 14px 14px 0px;background-color: #fff;}
		.user>.content .userDetail>.detail{color: #fff;font-size: 14px;margin:15px 0px 20px 0px ;}
		.user>.content .userDetail>.price{display: flex;align-items: center;}
		.user>.content .userDetail>.price>.l{color: #fff;font-size: 18px;line-height: 30px;margin-right: 55px;display: flex;align-items: center;}
		.user>.content .userDetail>.price>.l>span{color: #F7FA04;font-size: 30px;}
		.user>.content .userDetail>.price>.r{width: 160px;height: 39px;color:  #FFFFFF;;border: 1px solid #FFFFFF;text-align: center;box-sizing: border-box;border-radius: 19.5px;line-height: 37px;cursor: pointer;}
		.user>.content .userList{margin-left: 60px;margin-top: 80px;display: flex;}
		.user>.content .userList>div{width: 90px;height: 90px;margin-right: 10px;}
		.user>.content .userList>div>img{width: 100%;}
		.user>.button{width: 412px;height: 66px;font-size: 24px;color:  #FFFFFF;background: linear-gradient(83deg, #F20E23, #F76636);text-align: center;box-sizing: border-box;border-radius: 33px;line-height: 66px;cursor: pointer;display: flex;align-items: center;justify-content: center;margin: 0px auto;margin-top: 40px;}
		.user>.button>img{width:26px;height: 26px;margin-left: 14px;}
	}
	@media (min-width:	1200px) {
		.user{width: 100%;}
		.user>.title{width: 393px;height: 71px;background-image: url("../images/home/titbj.png");margin: 0px auto;background-size:100% 100% ;margin-top: 76px;font-size: 48px;font-weight: bold;text-align: center;}
		.user>.title>.t1{color: #000;}
		.user>.title>.t2{color: #E23737;}
		.user>.tail{color: #E2E2E2;font-size: 16px;text-align: center;}
		.user>.content{height:455px;margin-top: 40px;background-image: url("../images/home/userbj.png");background-repeat: no-repeat;background-size: 100% 100%;}
		.user>.content .userImg{position: relative;top: -40px;width: 293px;height: 407px;}
		.user>.content .userImg>.bj{width: 293px;height: 407px;}
		.user>.content .userImg>.img{width: 285px;height: 430px;position: absolute;top: 20px;left: -20px;}
		.user>.content .userDetail{margin-left: 60px;margin-top: 10px;}
		.user>.content .userDetail>.name{display: flex;align-items: center;}
		.user>.content .userDetail>.name>.l{color: #fff;font-size: 36px;margin-right: 20px;}
		.user>.content .userDetail>.name>.r{width: 137px;height: 38px;color: #E23737;font-size: 18px;text-align: center;line-height: 38px;border-radius: 17px 17px 17px 0px;background-color: #fff;}
		.user>.content .userDetail>.detail{color: #fff;font-size: 15px;margin:19px 0px 27px 0px ;}
		.user>.content .userDetail>.price{display: flex;align-items: center;}
		.user>.content .userDetail>.price>.l{color: #fff;font-size: 18px;line-height: 30px;margin-right: 55px;display: flex;align-items: center;}
		.user>.content .userDetail>.price>.l>span{color: #F7FA04;font-size: 30px;}
		.user>.content .userDetail>.price>.r{width: 160px;height: 39px;color:  #FFFFFF;;border: 1px solid #FFFFFF;text-align: center;box-sizing: border-box;border-radius: 19.5px;line-height: 37px;cursor: pointer;}
		.user>.content .userList{margin-left: 60px;margin-top: 80px;display: flex;}
		.user>.content .userList>div{width: 90px;height: 90px;margin-right: 10px;}
		.user>.content .userList>div>img{width: 100%;height: 100%;}
		.user>.button{width: 412px;height: 66px;font-size: 24px;color:  #FFFFFF;background: linear-gradient(83deg, #F20E23, #F76636);text-align: center;box-sizing: border-box;border-radius: 33px;line-height: 66px;cursor: pointer;display: flex;align-items: center;justify-content: center;margin: 0px auto;margin-top: 40px;}
		.user>.button>img{width:26px;height: 26px;margin-left: 14px;}
	}
</style>



// WEBPACK FOOTER //
// src/views/home/item5.vue